import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useCallback, useContext, useState } from 'react';
import DealerAd from '../..';
import { useWixDealerListener } from '../../DealerAdIframe';
import ddt from '@wix/da-ddt';
import cn from 'classnames';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import axios from 'axios';
import { yieldToMainAsync } from '@wix/da-hooks/pkg/yieldToMain';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './Adhesion.scss';
const AdhesionAdUnit = ({ realEstateId })=>{
    const [isVisible, setIsVisible] = useState(false);
    const [passedOffer, setPassedOffer] = useState(undefined);
    const [isHidden, setIsHidden] = useState(false);
    const isMounted = useIsMounted();
    const { biClientIdSigned, biClientId, useridUuid } = useContext(SessionContext);
    const handler = useCallback((data)=>{
        ddt.log('dealer', 'Got command from iframe2', data);
        switch(data.command){
            case 'show-adhesion':
                setIsVisible(true);
                setPassedOffer(data.data);
                break;
            default:
                break;
        }
    }, []);
    useWixDealerListener(realEstateId, handler);
    const closeHandler = useCallback(async ()=>{
        await yieldToMainAsync();
        setIsHidden(true);
        await yieldToMainAsync();
        const userId = useridUuid === '' ? biClientId : useridUuid;
        const params = {
            realEstateId,
            offerId: passedOffer.offerGuid,
            userId: userId,
            targetAccountId: userId,
            loggedInAccountId: userId
        };
        if (passedOffer) {
            // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
            axios.create().post(`https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer === null || passedOffer === void 0 ? void 0 : passedOffer.offerGuid}`, {
                deviantArtUserId: biClientIdSigned,
                event: _object_spread({
                    type: 'CLOSE'
                }, params)
            }, {
                headers: {}
            }).catch((e)=>{});
            // https://bo.wix.com/wix-docs/rest/internal-tools/dealer-offer-events/report-event
            axios.create().post(`https://www.wix.com/_api/dealer-offer-events-service/proxy/v1/dealer-offer-events/${passedOffer === null || passedOffer === void 0 ? void 0 : passedOffer.offerGuid}`, {
                deviantArtUserId: biClientIdSigned,
                event: _object_spread({
                    type: 'SHOW_LATER'
                }, params)
            }, {
                headers: {}
            }).catch((e)=>{});
        }
    }, [
        biClientId,
        biClientIdSigned,
        passedOffer,
        realEstateId,
        useridUuid
    ]);
    if (isHidden || !isMounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "AdhesionAdUnit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isVisible && s['visible'])
    }, /*#__PURE__*/ React.createElement(DealerAd, {
        disableLazy: true,
        className: s['unit'],
        realEstateId: realEstateId,
        extraParams: process.env.NODE_ENV === 'development' ? {
            forcefixture: 'adhesion'
        } : {}
    }), /*#__PURE__*/ React.createElement(IconButton, {
        className: s['close'],
        "aria-label": "Hide Advertisment",
        icon: Close,
        size: 'small',
        onClick: closeHandler
    })));
};
AdhesionAdUnit.displayName = 'AdhesionAdUnit';
export default AdhesionAdUnit;

//# sourceMappingURL=Adhesion.js.map